<script lang="ts">
  import { googleLogout } from "google-oauth-gsi";
  import { userSignedIn, showOverlay } from "./store";

  function logout() {
    localStorage.removeItem("googleToken");
    localStorage.removeItem("validatedPromoCode");
    // document.getElementById("deobfuscate").classList.add("grey-overlay");
    // document.getElementsByClassName("purchase-button").forEach((element) => {
    //   element.classList.add("grey-overlay");
    // });
    // document.getElementById("deobfuscate").classList.add("grey-overlay");
    // document.getElementById("purchaseButton1").classList.add("grey-overlay");
    // document.getElementById("purchaseButton2").classList.add("grey-overlay");
    // document.getElementById("purchaseButton3").classList.add("grey-overlay");
    // document.getElementById("purchasePremium").classList.add("grey-overlay");
    // document.getElementById("purchasePremiumAnnual").classList.add("grey-overlay");
    // document.getElementById("premiumTitle").hidden = true;
    // document.getElementById("profilePicture").attributes.removeNamedItem("src");
    // set initials to "" to remove them 
    // screw it I'm lazy ill do it later
    // document.getElementById("profilePicture").innerHTML = "";    
    // document.getElementById("credits").innerHTML = "";
    // document.getElementById("profilePicture").innerHTML = '<img src="./profile.png" alt="Profile Picture" class="logo-image" />';
    // let greeting = "";
    // let timeOfDay = new Date().getHours();
    // greeting = `Good ${timeOfDay < 12 ? "morning" : timeOfDay < 18 ? "afternoon" : "evening"}, friend!`;
    // document.getElementById("greeting").innerHTML = greeting;

    // document.getElementById("status").innerHTML = "";

    // document.getElementById("signIn").style.display = "block";
    $userSignedIn = false;
    $showOverlay = false;
    googleLogout();
    window.history.replaceState({}, document.title, "/");
    window.location.reload();
  }
</script>

<button style="border: 2px solid #DDDDDD; outline: none;" on:click={logout}>
  <img id="logout" src="logout.png" alt="Logout" />
</button>
